import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Avatar, Box, Button, Divider, IconButton, ListItemIcon, Menu, MenuItem, Typography } from '@mui/material';
import { Logout } from '@mui/icons-material';
import { useAuth } from '../lib/auth';
import TripsbyStudioLogo from './TripsbyStudioLogo';

export default function AppLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const initials = user ? (user.name || user.email || '?').split(' ').map(s => s[0]).join('').toUpperCase().slice(0, 2) : '?';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: '#FAFAF9' }}>
      {/* The shell never prints. Any page that offers Print (see
          components/groups/export) needs the nav, logo and avatar off the
          paper, and hiding them here is the one place that holds for every
          page rather than each one re-hiding the shell itself. */}
      <Box sx={{ px: 4, py: 1.5, display: 'flex', alignItems: 'center', justifyContent: 'space-between', bgcolor: 'white', borderBottom: '1px solid #E5E7EB', '@media print': { display: 'none' } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
          <Box sx={{ cursor: 'pointer' }} onClick={() => navigate('/concierges')}><TripsbyStudioLogo width={160} /></Box>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button size="small" onClick={() => navigate('/concierges')}>Concierges</Button>
            <Button size="small" onClick={() => navigate('/groups')}>Groups</Button>
          </Box>
        </Box>
        {user && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="body2" color="text.secondary" sx={{ display: { xs: 'none', sm: 'block' } }}>{user.name || user.email}</Typography>
            <IconButton onClick={e => setAnchorEl(e.currentTarget)} size="small">
              <Avatar src={user.picture} alt={initials} sx={{ width: 36, height: 36, bgcolor: '#569469', border: '2px solid #569469', fontSize: 14, fontWeight: 600 }}>{initials}</Avatar>
            </IconButton>
            <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={() => setAnchorEl(null)} transformOrigin={{ horizontal: 'right', vertical: 'top' }} anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }} PaperProps={{ sx: { borderRadius: 2, mt: 1, minWidth: 200 } }}>
              <Box sx={{ px: 2, py: 1.5 }}><Typography fontWeight={600} fontSize={14}>{user.name || 'User'}</Typography><Typography variant="caption" color="text.secondary">{user.email}</Typography></Box>
              <Divider />
              <MenuItem onClick={() => { setAnchorEl(null); logout(); }}><ListItemIcon><Logout fontSize="small" /></ListItemIcon>Logout</MenuItem>
            </Menu>
          </Box>
        )}
      </Box>
      <Box sx={{ flex: 1, p: { xs: 2, sm: 3, md: 4 }, maxWidth: 1200, width: '100%', mx: 'auto', '@media print': { p: 0, maxWidth: 'none' } }}><Outlet /></Box>
    </Box>
  );
}
